function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import { AelfIcon } from "../../icon/AelfIcon";
var AelfSVGComponent = function AelfSVGComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.495 2.043c1.066-.935 2.738-.178 2.738 1.24v13.358l-2.5-2.091V5.16l-5.478 4.806-1.94-1.623 7.18-6.3Zm.239 21.058 2.5 2.091v3.525c0 1.419-1.672 2.176-2.738 1.24l-8.332-7.315H7.016a2.25 2.25 0 0 1-2.25-2.25v-8.788c0-.544.193-1.043.514-1.432l2.01 1.682h-.024v8.288h5.84l7.628 6.698V23.1Zm9.435 1.988a.4.4 0 0 1 .05.564l-1.09 1.303a.4.4 0 0 1-.564.05L5.27 7.518a.4.4 0 0 1-.05-.563L6.31 5.65a.4.4 0 0 1 .564-.05L30.17 25.089Z"
  }));
};
var componentName = 'MuteOutlined';
export var MuteOutlined = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(AelfIcon, _extends({
    component: AelfSVGComponent,
    ref: ref
  }, props));
});
MuteOutlined.displayName = componentName;